module.exports = __webpack_public_path__ + "static/media/bio-ml.1c102686.jpg";